import React from 'react'
// ##
import QuantityOffersTable from '../../modules/QuantityOffer/components/QuantityOffersTable'

export default function QuantityOfferPage() {
  return <QuantityOffersTable />
}
